module.exports = __webpack_public_path__ + "img/b2.d62406c8.png";